import React, {MutableRefObject, ReactNode} from "react";
import IconTimes from "@Icons/controls/IconTimes";
import Row from "@Containers/components/Row";

interface DialogProps {
    dialogRef: MutableRefObject<HTMLDialogElement>,
    children: ReactNode,
    className?: string,
    closeModal?: () => void,
}

/*
 * This is a new Modal component. It can be placed and triggered anywhere from components tree and is controlled by ref
 * outside of component. The component is completely empty and its function is to wrap children (content) in modal.
 */
function Dialog({dialogRef, children, className = "", closeModal}: DialogProps) {
    return (
        <dialog
            ref={dialogRef}
            className={`gb--dialog ${className}`}
        >
            {closeModal && (
                <Row reverse>
                    <button
                        type="submit"
                        onClick={closeModal}
                        style={{margin: 'unset'}}
                    >
                        <IconTimes/>
                    </button>
                </Row>
            )}
            {children}
        </dialog>
    )
}

export default Dialog